/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <ListOfPois {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section } from "@bw/bits"
import { ListOfPois as ListOfPoisModule } from "@bw/modules"
import usePoiCollection from "../../../hooks/usePoiCollection"

const ListOfPois = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  displaySearch,
  displayMap,
}) => {
  const pois = usePoiCollection()
  return (
    <Section {...{ suptitle, title, subtitle, button, buttonPosition }}>
      <ListOfPoisModule map={displayMap} search={displaySearch} pois={pois} />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on ListOfPoisModule {
 *   ...ListOfPoisModuleFragment
 * }
 *
 * This is also what you will get in the props of your ListOfPois
 * resolver component.
 */
export const query = graphql`
  fragment ListOfPoisModuleFragment on ListOfPoisModule {
    displaySearch
    displayMap
  }
`

export { ListOfPois }
